export const BOARD_SIZE = 4;
export const INITIAL_TILES = 2;
export const RARE_INITIAL_TILES = 2;
export const START_VALUE = 2;
export const WIN_VALUE = 2048;
export const MATRIX = [
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
];
